import type ChartAction from './ChartAction';

/**
 * Точка графика.
 *
 * title — текст тултипа, строки через \n. Тултип собирает потребитель:
 * график про предметную область ничего не знает.
 */
class ChartPoint {
  readonly date: Date;

  readonly value: number;

  readonly title: string;

  /** Ссылка на фрагменте первой строки тултипа (номер документа); null — без ссылки */
  readonly action: ChartAction | null;

  constructor(date: Date, value: number, title: string, action: ChartAction | null = null) {
    this.date = date;
    this.value = value;
    this.title = title;
    this.action = action;
  }
}

export default ChartPoint;
